module.exports = __webpack_public_path__ + "static/FCIC-1e21d9697d615ab8de5643b5a2870124.jpg";